import useAppLanguage from 'hooks/useAppLanguage';
import React, { useState } from 'react';

import { useNavigate } from '@tanstack/react-router';
import imgChevron from 'assets/icons/chevron.svg';
import RewardsModal from './RewardsModal';
import desktopXlargeImage from './assets/desktop_large_portfolio_banner.png';
import desktopImage from './assets/desktop_large_portfolio_banner.png';
import mobileImage from './assets/mobile_portfolio_banner.png';
import { Button, Typography } from '@altify/components';
import { useFunctionalCurrency } from 'hooks/products/useProducts';

interface PromoBannerProps {
  headerControls?: React.ReactNode;
}

/* BANNER SHOWNIN PORTFOLIO PAGE BLOCK */
const PromoBanner: React.FC<PromoBannerProps> = ({
  headerControls,
}) => {
  const { functionalCurrency: baseCurrency } = useFunctionalCurrency();
  const language = useAppLanguage();
  const navigate = useNavigate();

  const [showRewardsModal, setShowRewardsModal] = useState<boolean>(false);

  // @ts-ignore

  return (
    <>
      <div className="mx-2 my-4 md:mx-4 md:mt-2 md:mb-6 lg:my-0 lg:mx-0 relative rounded-lg lg:h-full lg:w-full overflow-hidden">
        <div className="flex flex-col justify-between h-full overflow-hidden relative z-10 border border-white rounded-3xl">
          <div className="hidden lg:block mt-4 mb-2 z-20 ml-4">
            {headerControls}
          </div>

          <div className="flex flex-col md:flex-row h-full">
            {/* CONTENT COL/VIEW */}
            <div className="flex flex-col basis-2/2 md:basis-3/5 justify-between xxl:basis-3/5 pb-4 md:pt-4 xxl:pt-6 md:px-4">
              {/* COPY */}
              <div className="p-4 md:px-0 w-full flex flex-col justify-between">
                <div className="z-10 flex flex-col">
                  <h2 className="font-semibold text-[1.25rem] leading-[1.5rem] md:text-[0.975rem] md:leading-[1.25rem] xxxl:text-5xl/10 text-center md:text-start" data-testid="banner-title">
                    Invite & Earn Rewards
                  </h2>
                  <h4 className="font-semibold text-[1.75rem] leading-[2.25rem] md:text-[1.975rem] md:leading-[2rem] xxxl:text-[3.125rem] xxxl:leading-[3.5rem] text-center md:text-start" data-testid="banner-subtitle">
                    Reward Your Friends & Earn
                  </h4>
                </div>
              </div>
              {/* MOBILE BANNER IMAGE */}
              <div className="flex flex-col items-center md:hidden -mt-16 -mb-4">
                <img src={mobileImage} className="w-[260px]" />
              </div>
              
              {/* BUTTONS */}
              <div className="flex flex-col items-center md:items-start">
                <div className="flex flex-row my-2 flex-wrap gap-4 justify-center">
                  <div>
                    <Button
                      onPress={() => {
                        setShowRewardsModal(true);
                      }}
                      className="py-2 basis-[160px]"
                      size='medium'
                      color='primary' 
                    >
                      <Typography
                        size="medium"
                        weight='medium'
                        className="w-full text-center text-white">
                        {'Invite Friends'}
                      </Typography>               
                      <div>
                        <img src={imgChevron} alt="action" className="ml-4" />
                      </div>
                    </Button>
                  </div>
                  <div>
                    <Button
                      onPress={() => {
                        navigate({ to: `/rewards` });
                      }}
                      className="py-2 basis-[160px]"
                      size='medium'
                      color='secondary' 
                    >
                      <Typography
                        size="medium"
                        weight='medium'
                        className="w-full text-center text-white">
                        {'Learn More'}
                      </Typography>               
                      <div>
                        <img src={imgChevron} alt="action" className="ml-4" />
                      </div>
                      </Button>
                  </div>
                </div>
              </div>
            </div>
            {/* BANNER COL/VIEW */}
            <div className="flex flex-col basis-2/4 md:basis-2/5 xxl:basis-2/5 h-full justify-center items-start">

              {/* TABLET->XL DESKTOP BANNER IMAGE */}
              <img src={desktopImage} className="absolute right-0 top-0 hidden md:block xxl:hidden w-[264px] -mt-[4.5%] -mr-[1%] lg:w-[70%] lg:-mt-[8%] lg:-mr-[12%]"  />

              {/* XXL DESKTOP BANNER IMAGE */}
              <img src={desktopXlargeImage} className="absolute right-0 top-0 hidden xxl:block w-[32%] lg:w-[40%] xl:w-[50%] xxl:w-[70%] xxxxl:w-[76%] xxl:-mt-[10%] xxxl:-mt-[12%] xxxxl:-mt-[18%] xxl:-mr-[14%] xxxxl:max-w-[70rem] xxxxl:r-[10%]"  />
            </div>
          </div>
        </div>
      </div>
      <RewardsModal
        show={showRewardsModal}
        close={() => setShowRewardsModal(false)}
      />
    </>
  );
};

export default PromoBanner;
